import styles from "./SplashScreen.module.css"
const SplashScreen = () => {
  return (
      <div className={styles.splash_container}>
          <span className={styles.splash_title}>A</span>
          <span className={styles.splash_title}>M</span>
          <span className={styles.splash_title}>B</span>
          <span className={styles.splash_title}>I</span>
          <span className={styles.splash_title}>E</span>
          <span className={styles.splash_title}>N</span>
          <span className={styles.splash_title}>T</span>
      </div>
  )
}

export default SplashScreen